import React, { Component } from 'react';

import types from "../../data/criterionTypes";
import Graph from './Graph';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    width: '100%',
    marginBottom: 26
  },
  titleText: {
    color: 'black',
    fontSize: 22,
    fontWeight: 'bold',
    paddingTop: 8,
    paddingBottom: 8,
    textAlign: 'right'
  },
  graphContainer: {
    minHeight: 400,
  },
  runningContainer: {
    minHeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  statusText: {
    color: 'black',
    fontSize: 22,
    fontWeight: 'bold',
    paddingTop: 8,
    paddingBottom: 8,
    textAlign: 'left',
  },
  card: {
    backgroundColor: 'white',
    padding: 16
  },
  descriptoinContainer: {
    paddingLeft: 16,
    paddingRight: 16
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexItems: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexItems: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  descText: {
    color: 'black',
    textAlign: 'center',
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 16
  },
  downloadButton: {
    marginTop: 26,
    paddingBottom: 26,
    justifyContent: 'center'
  },
  downloadButtonText: {
    color: '#4990E2',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    borderWidth: 0,
    cursor: 'pointer'
  }
};

export default class SubmissionCard extends Component {
  constructor(props) {
    super(props);
    this.findType = this.findType.bind(this);
  }

  findType(value) {
    for (var i = 0; i < types.LIST.length; i++) {
      if (value === types.LIST[i].value) {
        return types.LIST[i];
      }
    }
    throw new Error("did not find " + value + " in " + JSON.stringify(types.LIST));
  }

  renderDescription() {
    let selectedValues = (index) => this.props.data.selectedValues[index];
    let parseDate = (str) => {
      var year = str.substring(0, 4);
      var month = str.substring(4, 6);
      var date = str.substring(6);
      return year + "/" + month + "/" + date;
    }
    let transactionsDownloadButton = () =>
      <div style={{...styles.sortContainer, ...styles.downloadButton}}>
        <button style={styles.downloadButtonText} onClick={() => this._downloadButtonOnClick()}>Download Transaction Details</button>
      </div>;

    return (
      <div style={styles.descriptoinContainer}>
				<div>
					Filtering criteria:
					{this.props.data.selectedTypes.map((type, index) => (
					   <div key={index}>
						 	{type.label} between {type.preFix}{selectedValues(index).value.smallValue}{type.postFix} and {type.preFix}{selectedValues(index).value.largeValue}{type.postFix}
						 </div>
					   ))}
					<div>
						Holding {this.props.data.numberOfStocks} stocks with the {this.props.data.sortOrder} {this.findType(this.props.data.sortBy).label}
					</div>
					<div>
						Rebalancing {this.props.data.rebalanceFrequency} from {parseDate(this.props.data.startDate).toString()} to {parseDate(this.props.data.endDate)}
					</div>
				</div>
        { this.props.data.fileUrls ? transactionsDownloadButton() : null }
      </div>
    );
  }

  _downloadButtonOnClick() {
    const url = (this.props.data.fileUrls || {}).transactions;
    console.log("button on press", url);
    window.open(url, "_blank");
  }

  render() {
    var title = () =>
      <p style={styles.titleText}>{"Submission on " + this.props.data.submissionDate}</p>
    var renderGraph = () =>
      <div style={styles.graphContainer}>
        <Graph url={this.props.data.fileUrls.graph}/>
      </div>
    var renderRunning = () =>
      <div style={styles.runningContainer}>
        <p style={styles.statusText}>Your backtest result will be ready soon...</p>
      </div>

    return (
      <div style={styles.container}>
        {this.props.data.submissionDate ? title() : null}
        <div style={styles.card}>
          {this.props.data.fileUrls ? renderGraph() : renderRunning()}
          {this.renderDescription()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubmissionCard.js